import React, { useRef } from "react";
import colors from "../../../utils/colors";
import { useOutsideCloseModal } from "../../../hooks/useOutsideClickModal";

interface IProps {
  appointmentStatus?: string;

  openDetailsModal?: React.Dispatch<React.SetStateAction<boolean>>;
  openRescheduleModal?: React.Dispatch<React.SetStateAction<boolean>>;
  openCancelModal?: React.Dispatch<React.SetStateAction<boolean>>;
  openCompleteModal?: React.Dispatch<React.SetStateAction<boolean>>;

  onClose?: React.Dispatch<React.SetStateAction<boolean>>;
}

const ActionsList = ({
  appointmentStatus,
  onClose,
  openCancelModal,
  openDetailsModal,
  openRescheduleModal,
  openCompleteModal,
}: IProps) => {
  const ref = useRef<HTMLDivElement | null>(null);
  useOutsideCloseModal({ ref, setShowModal: onClose });

  const isCompleted = appointmentStatus === "Completed";

  const handleClick = (
    openFn: React.Dispatch<React.SetStateAction<boolean>>
  ) => {
    openFn(true);
    onClose?.(false);
  };

  const baseClass =
    "p-2 text-xs cursor-pointer hover:bg-[#D0D0D0] hover:font-bold";

  const disabledClass = "opacity-50 cursor-not-allowed";

  return (
    <div
      ref={ref}
      className="absolute bg-[whitesmoke] p-2 w-[180px] right-[-5px] drop-shadow-lg top-[50px] z-50"
    >
      <div className="flex flex-col gap-1" style={{ color: colors.dark }}>
        <div
          className={baseClass}
          onClick={() => openDetailsModal && handleClick(openDetailsModal)}
        >
          View Details
        </div>

        {!isCompleted && (
          <div
            className={baseClass}
            onClick={() =>
              openRescheduleModal && handleClick(openRescheduleModal)
            }
          >
            Edit / Reschedule / Fix Follow Up
          </div>
        )}

        <div className={`${baseClass} ${disabledClass}`}>Message</div>

        {!isCompleted && (
          <div
            className={baseClass}
            onClick={() => openCancelModal && handleClick(openCancelModal)}
          >
            Cancel
          </div>
        )}

        {!isCompleted && openCompleteModal && (
          <div
            className={baseClass}
            onClick={() => handleClick(openCompleteModal)}
          >
            Mark as Completed
          </div>
        )}
      </div>
    </div>
  );
};

export default ActionsList;
